// src/contexts/ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// Protected route wrapper component that checks for authentication and role
const ProtectedRoute = ({ children, allowedRoles, redirectPath = "/" }) => {
  // Get authentication status and user data from Redux store
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // Extract user's role from Redux state
  const userRole = user?.role || null;

  // For debugging
  console.log("Auth check:", isAuthenticated, "Role:", userRole, "Allowed:", allowedRoles);

  // Check if the user's role is allowed for this route
  const isRoleAllowed = allowedRoles.includes(userRole);

  // If not authenticated or role not allowed, redirect to the specified path
  if (!isAuthenticated || !isRoleAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  // If authenticated and role is allowed, render the children or outlet
  return children ? children : <Outlet />;
};

// Specific route protectors for different roles
export const AdminRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["Admin"]}>{children}</ProtectedRoute>
);

export const OrgAdminRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["OrgAdmin"]}>{children}</ProtectedRoute>
);

export const InterviewerRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["Interviewer"]}>{children}</ProtectedRoute>
);

export const TP_InterviewerRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["TP-Interviewer"]}>{children}</ProtectedRoute>
);


export const HRRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["HR"]}>{children}</ProtectedRoute>
);


export const CandidateRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["Candidate"]}>{children}</ProtectedRoute>
);

// Combined route for multiple roles
export const StaffRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={["Admin", "OrgAdmin", "Interviewer"]}>{children}</ProtectedRoute>
);

export default ProtectedRoute;